import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardTitle } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelect } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { RangeStartValuePipe } from '../../../shared/pipes/range-start-value-pipe-pipe';
import { Distribution, DistributionDataI, ListItem, ModalListItemI, Stock } from '../../../shared/model';
import { ToastrService } from '../../../shared/services/toastr-service';
import { StockService } from '../../service/stock-service';
import { SweetAlertService } from '../../../shared/services/sweet-alert-service';
import { StockGroupeService } from '../../service/stock-groupe-service';
import { ListModalComponent } from '../../../shared/components/list-modal-component/list-modal-component';

interface ModalShareDataI {
  title : string
  site_id ?: string,
  groupe_id ?: string
}

@Component({
  selector: 'app-dist-modal',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatIcon,
    MatAutocompleteModule,
    MatSelect,
    MatTooltip,
    MatListModule,
    FormsModule
],
  templateUrl: './distribution-details-components.html',
  styleUrl: './distribution-details-components.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DistributionDetailsComponents {
  readonly dialogRef = inject(MatDialogRef<DistributionDetailsComponents>);

  // recupere les donnees envoyes par le parent
  readonly inputData = inject<ModalShareDataI>(MAT_DIALOG_DATA);

  // retourne le donne vers le parent

  distForm : FormGroup = new FormGroup({})

  readonly dialog = inject(MatDialog);

  err : boolean = false

  distributionData! : DistributionDataI
  compagniesNameList : ListItem[] = []
  typeDocList : {type : string}[] = []
  currentDistribution : Distribution[] = []
  currentQteSelected = signal<number>(0)

  stocks = signal<any[]>([])

  constructor(
    private fb : FormBuilder,
    private toastr : ToastrService,
    private stockService : StockService,
     private stockGroupeService : StockGroupeService,
    private sweetAlert : SweetAlertService
  ){

  }

  ngOnInit(): void {
    this.distForm = this.fb.group({
      compagnie_id : ["", [Validators.required]],
      compagnie_name : [{value : '', disabled : true}, [Validators.required]],
      type : ['', [Validators.required]]
    })

    console.log(this.inputData);
    

    if(this.inputData.site_id!){
      this.stockService.getDocuments(this.inputData.site_id).subscribe({
        next : (res) =>{
          this.distributionData = res
          this.compagniesNameList = res.compagnies.map(item => {
            return {'id' : item.compagnie_id, 'name' : item.compagnie_name}
          })
        },
        error : (err) =>{
          console.log(err);

        }
      })
    }else if(this.inputData.groupe_id){
      this.stockGroupeService.getDocuments(this.inputData.groupe_id).subscribe({
        next : (res) =>{
          this.distributionData = res
          this.compagniesNameList = res.compagnies.map(item => {
            return {'id' : item.compagnie_id, 'name' : item.compagnie_name}
          })
        },
        error : (err) =>{
          console.log(err);

        }
      })
    }


  }

  ngAfterViewInit(): void {

  }

  resetForm(){
    this.distForm.patchValue({

    })
  }

  selectCompagnie(){
    console.log(this.compagniesNameList);

    const data : ModalListItemI = {
      title : "Compagnies",
      data : this.compagniesNameList
    }

    const dialogRef = this.dialog.open(ListModalComponent, {
      width : '700px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : ListItem) => {

      if (result.id != '') {
        const compagnie = this.compagniesNameList.filter(item => item.id == result.id)[0]
        this.distForm.get('compagnie_id')?.setValue(compagnie.id)
        this.distForm.get('compagnie_name')?.setValue(compagnie.name)
        //
        this.distForm.get('type')?.setValue("")
        this.currentDistribution.splice(0, this.currentDistribution.length)
        this.typeDocList.splice(0, this.typeDocList.length)
        //
        // recuperer le type de doc disponible dans la liste de distribution
        const types = this.distributionData.types.filter(item => item.compagnie_id == compagnie.id)

        this.typeDocList.push(...types)
        console.log(this.typeDocList);
      }
    });
  }

  onSelectedType(type : string){
    //filter les distribution
    const compagnie_id = this.distForm.get('compagnie_id')?.value

    this.currentDistribution = this.distributionData.distributions!.filter(item => item.compagnie_id == compagnie_id && item.type == type)

    this.currentDistribution.forEach(item => this.stocks().push(new Stock()))

    this.distForm.get('qte')?.setValue("")
    this.distForm.get('qte')?.setValidators(Validators.max(this.currentQteSelected()))
  }

  onSelectQte(qte : string){
    //filtrer les distributions en fonction de la qte entrer
    if(this.inputData.groupe_id){
      this.currentDistribution = this.distributionData.distributions!.filter(item => item.reste >= parseInt(qte))
    }else if(this.inputData.site_id){
      this.currentDistribution = this.distributionData.stock_groupe!.filter(item => item.reste >= parseInt(qte))
    }else{
      this.currentDistribution = []
    }
  }

  stringToNumber(val : string){
    return parseInt(val)
  }

  calculRangeEndValue(quantite : string, range : string){
    let qte = parseInt(quantite)
    if(isNaN(qte) || qte == 0)return 'de 0 à 0'

    const rangeData = range.split("-")
    const startValue = parseInt(rangeData[0])
    const endValue = (startValue + (qte-1))

    return "de "+startValue+" à "+ endValue
  }

  generateDocuments(id : string, quantite : string, attestationRange : string, carteRaseRange : string, index : number){
    const qte = parseInt(quantite)
    if(isNaN(qte) || qte == 0){
      this.currentQteSelected.update(som => 0)
      return;
    }

    const attestaion = attestationRange.split("-").map(item => parseInt(item))
    const carteRose = carteRaseRange.split("-").map(item => parseInt(item))

   
    this.stocks()[index].attestation_range = attestaion[0]+"-"+(attestaion[0] + (qte-1))
    this.stocks()[index].carte_rose_range = carteRose[0]+"-"+(carteRose[0] + (qte-1))
    this.stocks()[index].reste = qte
    this.stocks()[index].type = this.distForm.get('type')?.value
    
    if(this.inputData.groupe_id){
      this.stocks()[index].groupe_id = this.inputData.groupe_id
      this.stocks()[index].distribution_id = id
    }else if(this.inputData.site_id){
      this.stocks()[index].site_id = this.inputData.site_id
      this.stocks()[index].stock_groupe_id = id
    }

    let cpt = 0
    this.stocks().forEach(item => cpt+=item.qte)
    this.currentQteSelected.update(som => cpt)

  }

  maxQteValue(qte : string, reste : number){
    if(parseInt(qte) > reste){
      this.err = true
      return this.err
    }

    this.err = false
    return this.err
  }

  onShare(){
    const data = this.stocks().filter(item => item.qte>0)
    this.sweetAlert.confirm("Etez-vous sur de vouloir valider cette distribution")
    .then((res) =>{
      if(res.isConfirmed){
        if(this.inputData.groupe_id){
           this.stockGroupeService.create(data).subscribe({
              next : (res) =>{
                console.log(res);
                this.sweetAlert.success("Operation reussie", 2000)
                this.distForm.reset()
                this.dialogRef.close(res)
              },
              error : (err) =>{
                this.toastr.error("Une erreur est survenue")
              }
            })
        }else if(this.inputData.site_id){
           this.stockService.create(data).subscribe({
              next : (res) =>{
                console.log(res);
                this.sweetAlert.success("Operation reussie", 2000)
                this.distForm.reset()
                this.dialogRef.close(res)
              },
              error : (err) =>{
                this.toastr.error("Une erreur est survenue")
              }
            })
        }
      }
    })
    console.log(data);

  }
}